import React from 'react';

import { Result } from 'antd';

import { FluxStatusType } from './types';

export const statusIconMapping: FluxStatusType = {
  SUCCESS: <Result className="FluxStatus" status="success" />,
  ERROR: <Result className="FluxStatus" status="error" />,
  WARNING: <Result className="FluxStatus" status="warning" />,
};

export const statusIconMappingAntai: FluxStatusType = {
  SUCCESS: <Result className="FluxStatus" status="success" />,
  ERROR: <Result className="FluxStatus" status="error" />,
  WARNING: <Result className="FluxStatus" status="warning" />,
};
